import React from 'react';
import i18n from 'i18next';
import { createRoot } from '@/util/hmr';

import AppContainer from '../../exceed/containers/appContainer';
import IntellumAiCta from '../../exceed/components/intellumAiCta';

const FeatureWrapper = () => (
  <IntellumAiCta
    redirectToUpNext
    title={i18n.t('not-sure-what-to-take-next')}
    body={i18n.t('let-intellum-ai-new-activities-suggest')}
  />
);

export default function renderAiCta(containerId = 'search-intellum-ai-cta') {
  const container = document.getElementById(containerId);
  if (!container) return;

  const root = createRoot(container);
  root.render(
    <AppContainer config={{ shouldLoadTranslations: true }}>
      <FeatureWrapper />
    </AppContainer>
  );
}
